export default "__VITE_ASSET__d73e61bf__"